var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-flex',{attrs:{"flexDirection":"row","flexWrap":"wrap","p":"4"}},_vm._l((_vm.companies),function(company,i){return _c('c-box',{key:i,attrs:{"mb":"3","mr":"3","w":"220px","align":"center"}},[_c('company-item-card',{attrs:{"company":company}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }